import { LeftNavItemInterface } from "../interfaces";
import { useAuthenticatedUserRole } from "../hooks";
import { SUPER_ACCESS_ROLE, RESTRICTED_PAGE_KEYS } from "../constants";

export const filterNavItemsByRole = (navItems: LeftNavItemInterface[]) => {
  const userRole = useAuthenticatedUserRole();

  if (!userRole) {
    return null;
  }
  // If the user is an ADMIN, return all navigation items
  if (SUPER_ACCESS_ROLE.includes(userRole)) {
    return navItems;
  } else {
    // Filter out restricted navigation items for non-ADMIN roles
    return navItems.filter((items) => {
      return !RESTRICTED_PAGE_KEYS.includes(items.key);
    });
  }
};
